import React           from 'react'
import PropTypes       from 'prop-types'
import PriceMatrix     from 'pu-react/components/PriceMatrix';
import OffshoreWrapper from './price_china/OffshoreWrapper'
import Notes           from './price_china/Notes'
import PriceMatrixCell from './price_china/PriceMatrixCell'

const PriceChina = (props) => {
  const { quote, parametersChanged, onPriceSelect, showSummary, parameters } = props
  if (!quote || !quote.line_items) return null;

  const lineItem = quote.line_items.find(li => li.quote_config_key === 'whx-grpb');
  if (!lineItem) return null

  if (showSummary && parameters.supplier_selected.indexOf('whx') < 0) return null;

  return (
    <div className="mb-4">
      <div className="price-offshore">
        <OffshoreWrapper>
          <div className="">
            <div className="d-flex flex-column">
              <h2 className="text-nowrap">China PCBs</h2>
              <div className="text-danger pb-2">
                <span>Please note that any applicable import tariffs will be charged by the shipping company.</span>
              </div>
            </div>
            <PriceMatrix
              tableSm
              tableStripe={false}
              lineItem={lineItem}
              supplier={lineItem.product_key}
              parametersChanged={parametersChanged}
              matrixCell={PriceMatrixCell}
              onPriceSelect={onPriceSelect}
              parameters={props.parameters}
              parametersCustomer={props.parametersCustomer}
              showSummary={props.showSummary}
              rowSelected={props.rowSelected}
              groupName="prices_f" />
            {!showSummary && <Notes />}
          </div>
        </OffshoreWrapper>
      </div>
    </div>
  )
}

PriceChina.propTypes = {
  quote: PropTypes.object.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
  parametersCustomer: PropTypes.object.isRequired,
  showSummary: PropTypes.bool.isRequired,
  rowSelected: PropTypes.number,
}

export default PriceChina
